module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dMJjc"))).then(() => parcelRequire('1iHdE'));